export const REVIEW_STATUS = {
  SUBMITTED: 'yplan_review',
  DRAFTS: 'partner_review',
}

export const STAGE_STATUS = {
  BASIC_DETAILS: 'BASIC_DETAILS',
  CALENDAR: 'CALENDAR',
  ADVANCED_DETAILS: 'ADVANCED_DETAILS',
  SUMMARY: 'SUMMARY',
  VOUCHERS: 'VOUCHERS',
}



/** WEBPACK FOOTER **
 ** ./src/constants/setupform-constants.js
 **/